
export const isYouTubeLink = (url:string) => {
	try {
		const u = new URL(url);
		return ["www.youtube.com", "youtube.com"].includes(u.hostname);
	}
	catch{}
	return false;
};
